import _ from 'lodash'
import Vue from 'vue'
import { initialState } from './state'
export default {
    changeState,
    openModal,
    closeModal,
    doneLoading,
    isLoading,
    setCourseStateList,
    setStudentCompletionList,
    setAffiliateScheduleList,
    setStudentExceptionList,
    clearStudentCompletionList,
    clearStudentExceptionList,
    clearStudentCompletionForm,
    clearAffiliateScheduleList,
    clearAffiliateScheduleForm,
    updateStudentCompletionList,
    updateStudentCompletionForm,
    updateAffiliateScheduleList,
    updateAffiliateScheduleForm,
    updateSelectedSchedules,
    updateSelectedStudents,
    removeSelectedSchedules,
    removeSelectedStudents,
    resetState
}

function changeState (state, { area, field, val }) {
    state[area][field] = val
}

function isLoading (state) {
    state.loading = true
}

function doneLoading (state) {
    state.loading = false
}

function openModal (state, modalRoute) {
    let route = state[modalRoute + "State"]
    if (route !== undefined) {
      state[modalRoute + "State"] = true
    } else {
      notify.create({
        message: "Not Yet Implemented!",
        type: "negative"
      })
    }
}
  
function closeModal (state, modal) {
state[modal + "State"] = false
}

function setCourseStateList (state, stateCourseList) {
    state.stateCourseList = stateCourseList
    state.studentCompletionForm.COURSE_ID = null
}

function setStudentCompletionList (state, studentCompletionList) {
    state.studentCompletionList = studentCompletionList
}

function setStudentExceptionList (state, studentExceptionList) {
    state.studentExceptionList = studentExceptionList
}

function setAffiliateScheduleList (state, affiliateScheduleList) {
    state.affiliateScheduleList = affiliateScheduleList
}

function clearStudentCompletionList (state, studentCompletionList) {
    state.studentCompletionList = []
}

function clearStudentExceptionList (state, studentExceptionList) {
    state.studentCompletionList = []
}

function clearAffiliateScheduleList (state, affiliateScheduleList) {
    state.affiliateScheduleList = []
}

function clearStudentCompletionForm (state) {
    _.each(state.studentCompletionForm, (value, key) => {
        state.studentCompletionForm[key] = initialState.studentCompletionForm[key]
    })
}

function clearAffiliateScheduleForm (state) {
    _.each(state.affiliateScheduleList, (value, key) => {
        console.log(key)
        state.affiliateScheduleForm[key] = initialState.affiliateScheduleForm[key]
    })
}

function updateStudentCompletionList (state, { index, field, value }) {
    Object.assign(state.studentCompletionList[index], {
        [field]: value
    })
}

function updateStudentCompletionForm (state, { field, value }) {
    Object.assign(state.studentCompletionForm, {
      [field]: value
    })
}

function updateAffiliateScheduleList (state, { index, field, value }) {
    Object.assign(state.affiliateScheduleList[index], {
        [field]: value
    })
}

function updateAffiliateScheduleForm (state, { field, value }) {
    Object.assign(state.affiliateScheduleForm, {
      [field]: value
    })
}

function updateSelectedSchedules (state, selectedSchedules) {
    state.selectedSchedules = [...selectedSchedules]
}

function updateSelectedStudents (state, selectedStudents, index) {
    state.selectedStudents = [...selectedStudents]
}

function removeSelectedSchedules (state) {
    Vue.set(state, 'affiliateScheduleList', _.pullAllBy(_.cloneDeep(state.affiliateScheduleList), _.cloneDeep(state.selectedSchedules), '__index'))
    state.selectedSchedules = []
}

function removeSelectedStudents (state) {
    const selectedIndexes = state.selectedStudents.map(item => item.__index)
    selectedIndexes.forEach((item) => {
        delete state.studentCompletionList[item]
    })
    Vue.set(state, 'studentCompletionList', state.studentCompletionList.filter(item => item))
    state.selectedStudents = []
}

function resetState (state) {
    // _.each(state, (value, key) => {
    //     state[key] = initialState[key]
    // })
    state = { ...initialState }
}
